import React, { Component } from 'react';
import styles from './style.css';

class Adbanner extends Component {
    constructor() {
        super();
        this.state = {
            isRender: true,
            bannerShow: false,
        };
    }
    componentDidMount() {
        this.refs['bannerclose'].addEventListener('click', () => {
            this.setState({
                bannerShow: false,
            });
        });
    }
    hide() {
        this.setState({
            showItem: false,
            bannerShow: false,
        });
    }
    show() {
        this.setState({
            showItem: true,
            bannerShow: true,
        });
    }
    // 点击关闭banner广告
    bannerClose() {
        this.setState({
            bannerShow: false,
        });
    }

    destory() {
        this.setState({
            isRender: false,
        });
    }

    render() {
        const { isRender, showItem, bannerShow } = this.state;
        const children = isRender ? (
            <div
                style={{ display: showItem ? 'block' : 'none' }}
                ref={c => {
                    this.el = c;
                }}
                className={bannerShow ? styles.videobannerShow : styles.videobanner}
                id="js_videobanner_container">
                <i className={styles.bannerclose} id="js_banner_close" ref="bannerclose" />
                <i className={styles.bannericon} />
            </div>
        ) : null;

        return children;
    }
}

export default Adbanner;
